<template>
  <b-container fluid class="py-5">
    <!-- Header -->
    <!-- <b-row class="mb-4">
      <b-col>
        <b-alert show class="gradient-alert shadow-md rounded-pill py-3 px-4 d-flex align-items-center pulse-animation">
          <i class="fas fa-book mr-3" style="font-size: 1.5rem; color: #fff;"></i>
          <span class="font-weight-bold text-white" style="font-size: 1rem;">
            RUJUKAN: Sumber Rujukan Penilaian Berdasarkan Nilai-Nilai H.E.M.A.T.
          </span>
        </b-alert>
      </b-col>
    </b-row> -->

    <!-- Rujukan Card -->
    <b-card no-body class="profile-card shadow-lg rounded-xl overflow-hidden">
      <b-card-header class="bg-gradient-teal animated-header py-5 px-5">
        <h2 class="mb-0 font-weight-bold text-uppercase text-white">Sumber Rujukan Penilaian</h2>
        <p class="mb-0 text-white-75" style="font-size: 0.95rem;">Berdasarkan Buku Panduan & Borang Pemarkahan</p>
      </b-card-header>
      <b-card-body class="p-5 glassmorphism-bg">
        <b-row>
          <b-col md="6" class="mb-4 fade-in" style="animation-delay: 0.1s;">
            <b-card class="h-100 shadow-sm border-0 hover-highlight">
              <div class="d-flex align-items-center mb-3">
                <i class="fas fa-book-open fa-2x text-primary mr-3"></i>
                <h5 class="mb-0 font-weight-bold text-dark">Definisi Nilai-Nilai H.E.M.A.T.</h5>
              </div>
              <p class="text-muted">
                Rujukan definisi rasmi Nilai-Nilai H.E.M.A.T. yang diperincikan dalam buku panduan H.E.M.A.T. bagi kefahaman dan pelaksanaan penilaian.
              </p>
              <b-button variant="primary" :href="definisiURL" target="_blank">
  Muat Turun PDF
</b-button>
            </b-card>
          </b-col>

          <b-col md="6" class="mb-4 fade-in" style="animation-delay: 0.2s;">
            <b-card class="h-100 shadow-sm border-0 hover-highlight">
              <div class="d-flex align-items-center mb-3">
                <i class="fas fa-file-alt fa-2x text-success mr-3"></i>
                <h5 class="mb-0 font-weight-bold text-dark">Contoh Borang Pemarkahan</h5>
              </div>
              <p class="text-muted">
                Panduan pemarkahan inisiatif berdasarkan elemen Nilai-Nilai H.E.M.A.T. untuk digunakan semasa sesi penilaian.
              </p>
              <b-button variant="success" :href="borangURL" target="_blank">
  Muat Turun PDF
</b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </b-container>
</template>

<script>
import { baseURLPdf } from '../../../services/baseURL';

export default {
  data() {
    return {
      definisiURL: baseURLPdf + 'definisi-hemat.pdf',
      borangURL: baseURLPdf + 'borang-pemarkahan.pdf'
    };
  }
};
</script>
